import React from "react";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import AppBar from "../components/appbar/appbar";
import BracketSection from "../components/appbar/BracketSection";
import CartCheckoutBottom from "../components/home/cart-checkout-page/CartCheckoutBottom";

export const CartCheckoutBottomPage = ({ storeKey }) => {
  return (
   <div className="market-layout">
        <Container fluid className="layout-container">
          <Row className="main-row no-gutters">
            <div style={{display: "flex",    width: "100%" }}>

            <AppBar activeOption="cart" />
            <BracketSection />

            <CartCheckoutBottom storeKey={storeKey}/>
            </div>
          </Row>
        </Container>
    </div>
  );
};
